import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {assignUserToDesignationInput, Designation, DesignationInput} from './designation.model';

export const loadDesignations = createAction(
  '[Designation/API] Load Designations',
  props<{ designations: Designation[] }>()
);

export const addDesignation = createAction(
  '[Designation/API] Add Designation',
  props<{ designation: Designation }>()
);

export const upsertDesignation = createAction(
  '[Designation/API] Upsert Designation',
  props<{ designation: Designation }>()
);

export const addDesignations = createAction(
  '[Designation/API] Add Designations',
  props<{ designations: Designation[] }>()
);

export const upsertDesignations = createAction(
  '[Designation/API] Upsert Designations',
  props<{ designations: Designation[] }>()
);

export const updateDesignation = createAction(
  '[Designation/API] Update Designation',
  props<{ designation: Update<Designation> }>()
);

export const updateDesignations = createAction(
  '[Designation/API] Update Designations',
  props<{ designations: Update<Designation>[] }>()
);

export const deleteDesignation = createAction(
  '[Designation/API] Delete Designation',
  props<{ id: string }>()
);

export const deleteDesignations = createAction(
  '[Designation/API] Delete Designations',
  props<{ ids: string[] }>()
);

export const clearDesignations = createAction(
  '[Designation/API] Clear Designations'
);


// CUSTOM

export const getAllDesignations = createAction(
  '[Designation/API] get Institution Designation',
  props<{ institutionUniqueId?: string }>()
);

export const createInstitutionDesignationMutation = createAction(
  '[Designation/API] create Institution Designation Mutation',
  props<{ input?: DesignationInput }>()
);

export const updateInstitutionDesignationMutation = createAction(
  '[Designation/API] create Institution Designation Mutation',
  props<{ input?: DesignationInput }>()
);


export const removeInstitutionDesignationMutation = createAction(
  '[Designation/API] delete Institution Designation Mutation',
  props<{ designationUniqueId: string,id:string }>()
);


export const assignUserToDesignationMutation = createAction(
  '[Designation/API] assign User To Designation Mutation',
  props<{ input?:assignUserToDesignationInput}>()
);

export const assignUserType = createAction(
  '[Designation/API] assign User Type Mutation',
  props<{ userType: string; profileUniqueId: string; }>()
);
